import styles from './WidescreenLock.module.less';
import ShowIf from '../UI/ShowIf';
import { isMobile } from 'react-device-detect';
import lock from '../../assets/images/ROTAR_DISPOSITIVO.svg';
import {EditorStore, useStore} from "../../store/createStore";
import {IText} from "fabric/fabric-impl";
import {useEffect, useState} from "react";

function WidescreenLock() {
  const activeObjectIText = useStore<EditorStore, IText>('activeObjectIText')[0];
  const [showScreenLock, setShowScreenLock] = useState(false);

  useEffect(() => {
    // Con este timeout se previene que durante cierto instante mientras se cierra el teclado del
    // dispositivo móvil se observe la pantalla de bloqueo de la aplicación
    setTimeout(() => {
      setShowScreenLock(!activeObjectIText);
    }, 400)
  }, [activeObjectIText]);

  return (
    <ShowIf condition={isMobile && showScreenLock}>
      <div className={`${styles['container-mobile']}`}>
        <div className="text-center flex flex-wrap justify-center">
          <img src={lock} alt="" />
          <span className="w-full text-secondary">
            Gira tu dispositivo <br /> para seguir creando.
          </span>
        </div>
      </div>
    </ShowIf>
  );
}

export default WidescreenLock;
